import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/fullscreen-page.scss';
import $ from 'jquery';

Component('tr-fullscreen-page', {
  mixins: [eventListenerMixin],

  properties: {
    excludeSelectors: {
      type: String,
      default: '.system-message, .header, tr-feature-banner',
    },
    heightOffset: {
      type: Number,
      default: 2,
    },
  },

  connected() {
    document.body.classList.add('body-fullscreen-page');
  },

  ready() {
    this.setHeight();
    this.listenTo(window, 'resize', this.setHeight.bind(this));
  },

  setHeight() {
    let excludeHeight = this.heightOffset;

    if (this.excludeSelectors) {
      [...document.querySelectorAll(this.excludeSelectors)].forEach((element) => {
        excludeHeight += $(element).outerHeight(true);
      });
    }

    this.style.height = `${window.innerHeight - excludeHeight}px`;
  },

  disconnected() {
    document.body.classList.remove('body-fullscreen-page');
    this.stopListening();
  },
});
